import { IServicesToPatient } from "@home-health-notify/domain";
import ServicesToPatient from "../../../chats/group/patient/ServicesToPatient";
import { MrnChip } from "../../../common/MrnChip";
import PatientStatusImage from "../../../common/PatientStatusImage";
import { GROUP_AVATAR_SIZE } from "../../../utils/AvatarUtils";
import {
  HeaderDescriptionContainer,
  MetaText,
  NameMetaWrapper,
  NameText,
  PatientHeaderDescriptionWrapper,
} from "../../MessageHeader.style";

export interface IPatientHeaderDescriptionProps {
  patientStatus: number;
  name: string;
  mrn?: string;
  meta?: string;
  servicesToPatient: IServicesToPatient[];
  avatarSize?: GROUP_AVATAR_SIZE;
  fontSizeTitle?: number;
}

export const PatientHeaderDescription = ({
  patientStatus,
  name,
  mrn,
  meta,
  servicesToPatient,
  avatarSize = GROUP_AVATAR_SIZE.MEDIUM,
  fontSizeTitle,
}: IPatientHeaderDescriptionProps) => {
  return (
    <HeaderDescriptionContainer data-testid="patient-header-description">
      <PatientStatusImage status={patientStatus} size={avatarSize} />
      <PatientHeaderDescriptionWrapper>
        <NameMetaWrapper>
          <NameText
            fontSize={fontSizeTitle ?? 16}
            data-testid="patient-group-name"
          >
            {name}
          </NameText>
          {mrn && <MrnChip mrn={mrn} />}
          {meta && <MetaText data-testid="patient-group-tag">{meta}</MetaText>}
        </NameMetaWrapper>
        <ServicesToPatient servicesToPatient={servicesToPatient} />
      </PatientHeaderDescriptionWrapper>
    </HeaderDescriptionContainer>
  );
};
